import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  showMenuItems: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isCustomerSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor() { }
  
  }
